import { DateTime } from 'luxon'
import { isoToFormat } from '~/app/utils/useIsoToFormat'

export function toISOByDateFormat(date: string, format = 'yyyy-MM-dd HH:mm:ss') {
  return DateTime.fromFormat(date, format).setZone('Asia/Seoul').toISO()
}

export function dateWithDayOfWeek(date: string) {
  return isoToFormat(date, 'yyyy.MM.dd (ccc)')
}

export function hourMinute(date: string) {
  return isoToFormat(date, 'HH:mm')
}

export function getNowSeoulDateTime(): string {
  return DateTime.now().setZone('Asia/Seoul').toISO()
}

export const isInPeriod = ({
  startDateTime,
  endDateTime,
}: {
  startDateTime: string
  endDateTime: string
}) => {
  const currentAt = DateTime.now()

  return (
    DateTime.fromFormat(startDateTime, 'yyyy-MM-dd HH:mm').diff(currentAt).toMillis() <= 0 &&
    DateTime.fromFormat(endDateTime, 'yyyy-MM-dd HH:mm')
      .minus({ milliseconds: 1 })
      .diff(currentAt)
      .toMillis() > 0
  )
}

export const isAfterDateTime = (dateTime: string) => {
  return DateTime.fromFormat(dateTime, 'yyyy-MM-dd HH:mm').diff(DateTime.now()).toMillis() <= 0
}

export const isSameDate = (date1: string, date2: string) =>
  DateTime.fromISO(date1).hasSame(DateTime.fromISO(date2), 'day')

/** 디바이스 타임존으로 변환 */
export const formatDeviceZoneText = (date: string, format: string) => {
  const deviceTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return DateTime.fromISO(date).setZone(deviceTimeZone).setLocale('ko-KR').toFormat(format)
}

/** 한국 시간(Asia/Seoul) 으로 변환 */
export const formatKstText = (date: string, format: string) => {
  return DateTime.fromISO(date).setZone('Asia/Seoul').setLocale('ko-KR').toFormat(format)
}
